export const Cross = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 21 21">

        <g fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" transform="translate(2 2)">
        
        <circle cx="8.5" cy="8.5" r="8"/>
        
        <g transform="matrix(0 1 -1 0 17 0)">
        
        <path d="m5.5 11.5 6-6"/>
        
        <path d="m5.5 5.5 6 6"/>
        
        </g>
        
        </g>
        
        </svg>
    )
}